/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resource_GuideInputs */

const en_directory_agents_resource_guide = /** @type {(inputs: Directory_Agents_Resource_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The complete content spec: JSON schema, vocabularies, SEO format, and a clone-and-fill example.`)
};

const zh_directory_agents_resource_guide = /** @type {(inputs: Directory_Agents_Resource_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整内容规范：JSON Schema、受控词表、SEO 格式与可克隆示例。`)
};

/**
* | output |
* | --- |
* | "The complete content spec: JSON schema, vocabularies, SEO format, and a clone-and-fill example." |
*
* @param {Directory_Agents_Resource_GuideInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resource_guide = /** @type {((inputs?: Directory_Agents_Resource_GuideInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resource_GuideInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resource_guide(inputs)
	return zh_directory_agents_resource_guide(inputs)
});
export { directory_agents_resource_guide as "directory.agents.resource_guide" }